import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import LoadingLayer from '@/shared/components/LoadingLayer';
import { isNativeWebview } from '@/utils/native-sdk';
import { storeCallbackLink, storeState } from '@/utils/social-connectors';

const Springboard = () => {
  const [searchParameters] = useSearchParams();

  useEffect(() => {
    // This bridge route is meaningful only inside a native SDK webview. Keeping it inert in an
    // ordinary browser prevents its query string from becoming a public open redirect.
    if (!isNativeWebview()) {
      return;
    }
    const state = searchParameters.get('state');
    const connectorId = searchParameters.get('connectorId');
    const callback = searchParameters.get('callback');
    const redirectTo = searchParameters.get('redirectTo');

    if (callback && connectorId) {
      storeCallbackLink(connectorId, callback);
    }

    if (state && connectorId) {
      storeState(state, connectorId);
    }

    if (redirectTo) {
      window.location.assign(redirectTo);
    }
  }, [searchParameters]);

  return <LoadingLayer />;
};

export default Springboard;
